import React from 'react'
import { Datagrid, TextField, useTranslate } from 'react-admin'
import { styled } from '@mui/material'
import { ListBase } from '../../components/base'
import { ImageField } from '../../components/fields'
import { PORTAL_MENUS_FIELDS } from '../../providers/localization/constant'

const PreviewImage = styled(ImageField)(() => ({
  '& .RaImageField-image': {
    width: 225,
    height: 150,
    objectFit: 'contain',
    borderRadius: 5,
  },
}))

const PortalMenuLists = (): JSX.Element => {
  const translate = useTranslate()
  return (
    <ListBase
      exporter={false}
      // sort={{ field: 'image_mobile', order: 'ASC' }}
      perPage={50}
      sort={{ field: 'order', order: 'ASC' }}
      noPagination
      listAction={{
        hasCreate: false,
      }}
    >
      <Datagrid rowClick='edit' bulkActionButtons={false}>
        <TextField
          label={translate(`${PORTAL_MENUS_FIELDS}.order`)}
          source='order'
          sortable={false}
        />
        <PreviewImage
          label={translate(`${PORTAL_MENUS_FIELDS}.image_desktop`)}
          source='image_desktop.full_path'
          sortable={false}
        />
        <PreviewImage
          label={translate(`${PORTAL_MENUS_FIELDS}.image_mobile`)}
          source='image_mobile.full_path'
          sortable={false}
        />
        <TextField
          label={translate(`${PORTAL_MENUS_FIELDS}.target_url`)}
          source='target_url'
          sortable={false}
        />
      </Datagrid>
    </ListBase>
  )
}

export default PortalMenuLists
